import { render, staticRenderFns } from "./videodialog.vue?vue&type=template&id=26324d01&scoped=true"
import script from "./videodialog.vue?vue&type=script&lang=js"
export * from "./videodialog.vue?vue&type=script&lang=js"
import style0 from "./videodialog.vue?vue&type=style&index=0&id=26324d01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26324d01",
  null
  
)

export default component.exports